import React, { createContext, useContext, useCallback } from "react";
import posthog from "../config/posthog";

interface PostHogContextType {
  captureEvent: (eventName: string, properties?: Record<string, any>) => void;
  capturePageView: (pageName: string) => void;
}

const PostHogContext = createContext<PostHogContextType | undefined>(undefined);

export const usePostHog = () => {
  const context = useContext(PostHogContext);
  if (context === undefined) {
    throw new Error("usePostHog must be used within a PostHogProvider");
  }
  return context;
};

interface PostHogProviderProps {
  children: React.ReactNode;
}

export const PostHogProvider: React.FC<PostHogProviderProps> = ({
  children,
}) => {
  const captureEvent = useCallback(
    (eventName: string, properties?: Record<string, any>) => {
      posthog.capture(eventName, properties);
    },
    []
  );

  const capturePageView = useCallback((pageName: string) => {
    posthog.capture("$pageview", { page: pageName });
  }, []);

  const value = {
    captureEvent,
    capturePageView,
  };

  return (
    <PostHogContext.Provider value={value}>{children}</PostHogContext.Provider>
  );
};
